import { ROMAN_NUMERALS } from '../constants/number';

/**
 * Переводит любое значение в числовое. Если параметр "не число", то возвращает 0
 * @param value - любое значение
 * @returns возвращает 0 или число
 */
export const toNumber = (value: string | number | null | undefined): number => {
  if (value == null) {
    return 0;
  }
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? 0 : numericValue;
};

/**
 * Переводит значение в числовое. Если параметр "не число", то возвращает null
 * @param value - любое значение
 * @returns возвращает 0 или число
 */
export const toNumberOrNull = (value: string | number | null | undefined): number | null => {
  if (value == null) {
    return null;
  }
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? null : numericValue;
};

/**
 * Возвращает количество знаков после запятой для отображения числа по диапазонам.
 * @param value - число или null
 * @returns количество знаков после запятой
 */
export const getAdaptiveDecimalPlaces = (value: Nullable<number>): number => {
  if (value == null) return 0;
  if (value > 0.0001 && value < 0.001) return 4;
  if (value > 0.001 && value < 0.01) return 3;
  if (value > 0.01 && value < 0.1) return 2;
  return 1;
};

/**
 * Преобразует арабскую цифру в римскую для диапазона 0–10.
 * Вне диапазона возвращает undefined.
 * @param number - число от 0 до 10, по умолчанию 0
 * @returns римская цифра, пустая строка для 0 или undefined вне диапазона
 */
export const getRomanNumber = (number = 0): string | undefined => ROMAN_NUMERALS[number];
